import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=295a0fa7&scoped=true&"
import script from "./TagView.vue?vue&type=script&lang=js&"
export * from "./TagView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295a0fa7",
  null
  
)

export default component.exports